import NextLink from "next/link";

import { cx } from "#ui/style.utils";

import { classNamesFooterLink } from "./footers-utils";

export function FooterLink({
  children,
  className,
  href,
  ...props
}: React.ComponentPropsWithoutRef<"a"> & {
  children: React.ReactNode;
  href: string;
}) {
  const classNames = cx(classNamesFooterLink, className);
  if (href.startsWith("http")) {
    return (
      <a
        {...props}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames}
      >
        {children}
      </a>
    );
  }
  return (
    <NextLink {...props} href={href} className={classNames}>
      {children}
    </NextLink>
  );
}
